import * as React from 'react';
import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import { Check } from 'lucide-react';
import { cn } from '@shared/lib/utils';

const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({ className, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn(
      'peer size-4 shrink-0 rounded-[4px] border border-base-border bg-background shadow-sm',
      'transition-[color,box-shadow,background-color,border-color] duration-normal ease-standard',
      'focus-visible:outline-none focus-visible:border-[#A3A3A3] focus-visible:shadow-[0_0_0_3px_rgba(163,163,163,0.5)]',
      'disabled:cursor-not-allowed disabled:opacity-50',
      'data-[state=checked]:border-base-primary data-[state=checked]:bg-base-primary data-[state=checked]:text-[#EEF2F7]',
      className,
    )}
    {...props}
  >
    <CheckboxPrimitive.Indicator className="flex items-center justify-center text-current">
      <Check className="size-3.5 stroke-[1.33]" />
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
));
Checkbox.displayName = CheckboxPrimitive.Root.displayName;

export { Checkbox };
